import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { boolAttr } from '@fs/zion-frontend-friends'
import { ArrowCaret } from '@fs/zion-icon'
import { Bleed, Card, colors, H3, Image, Paragraph, Row, Separator, usePageWidth } from '@fs/zion-ui'

import { ColorContext } from '../ColorProvider'

const iconCss = css`
  border-radius: 50%;
  height: 256px;
  width: 256px;
  margin-inline-end: -32px;
  margin-bottom: -32px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 96px;
    height: 96px;
  }

  &[data-mobile] {
    position: relative;
    height: 40px;
    width: 40px;
    margin: 0;

    svg {
      width: 22px;
      height: 22px;
    }
  }
`

function OfferIcon({ src, Icon }) {
  const isMobile = usePageWidth()({ default: true, xl: false })
  const { color, backgroundColor, iconPattern } = useContext(ColorContext)
  const size = isMobile ? 22 : 96

  return (
    <div
      css={iconCss}
      style={{
        backgroundColor,
        backgroundImage: isMobile ? undefined : `url(${iconPattern})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
      data-mobile={boolAttr(isMobile)}
    >
      {Icon ? <Icon color={color} /> : <Image noCrop height={size} width={size} src={src} />}
    </div>
  )
}

export default function BaseOfferCard({ title, description, src, onClick, to, external, Icon, linkName, ...props }) {
  const isMobile = usePageWidth()({ default: true, xl: false })
  return (
    <Card
      edges="none"
      backgroundColor={colors.gray02}
      margins={isMobile ? 'sm' : 'lg'}
      onClick={onClick}
      to={to}
      external={external}
      linkName={linkName}
      {...props}
    >
      {isMobile ? (
        <Row alignY="middle">
          <OfferIcon src={src} Icon={Icon} />
          <H3 size="H5" growX>
            {title}
          </H3>
          <ArrowCaret color={colors.gray100} size="md" />
        </Row>
      ) : (
        <>
          <H3 size="H4">{title}</H3>
          <Separator size="xs" />
          <Paragraph size="sm">{description}</Paragraph>
          <Separator size="xl" />
          <Bleed sides bottom style={{ height: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', height: '100%' }}>
              <OfferIcon src={src} Icon={Icon} />
            </div>
          </Bleed>
        </>
      )}
    </Card>
  )
}
